var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarkerSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.30964 11.0508C9.82356 11.0508 11.0508 9.82356 11.0508 8.30964C11.0508 6.79577 9.82356 5.56853 8.30964 5.56853C6.79573 5.56853 5.56853 6.79577 5.56853 8.30964C5.56853 9.82356 6.79573 11.0508 8.30964 11.0508Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30964 19C13.1523 14.7056 15.6193 11.0508 15.6193 8.30964C15.6193 6.37101 14.8491 4.51177 13.4784 3.14095C12.1076 1.77012 10.2483 1 8.30964 1C6.37101 1 4.51177 1.77012 3.14095 3.14095C1.77012 4.51177 1 6.37101 1 8.30964C1 11.0508 3.467 14.6142 8.30964 19Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerSmall);
export default __webpack_public_path__ + "static/media/map-marker-small.b3be013be2264ed03761b8e392253cd9.svg";
export { ForwardRef as ReactComponent };